export function getClientByTypes(client_id= null) {
  const client_types = [
    'client',
    'sub_client',
    'depot',
    'port',
    'intermodal_terminal',
    'delivery_collect',
  ];
  let client_by_type = {};
  let clients_list = new Promise((resolve, reject) => {
    // Uma chamada para os seis tipos: era um GET por tipo a cada abertura de
    // tela (Sentry 2KV). O objeto continua sendo preenchido quando a resposta
    // chega, como antes. `getJSON`: onde a rota responde HTML (portal da
    // transportadora, redirect de permissao) o callback nao roda; o `$.each`
    // na string estourava (Sentry 55Z).
    $.getJSON('/clients/client_by_type', { client_types, client_id }, (res) => {
      $.each(res, (type, clients) => {
        if (clients) {
          client_by_type[type] = clients;
        }
      });
    });
    resolve(client_by_type);
  });
  return clients_list;
}

export function showPlace(type) {
  $(`#${type}-city`).addClass('d-none');
  $(`#${type}-place`).removeClass('d-none');
}

export function showCity(type) {
  $(`#${type}-place`).addClass('d-none');
  $(`#${type}-city`).removeClass('d-none');
}

export function changeSelectValues(clientByType, clientType, type, select='_place_id') {
  const $select = $(`#${type}${select}`);
  const selectize = $select[0].selectize;
  selectize.clear();
  selectize.clearOptions();
  if (clientType) selectize.addOption(clientByType[clientType]);
}
